<template lang="pug">
.modal.fade.modalConnection(ref="modal")
  .modal-dialog
    .modal-content
      .modal-header
        button.close(type="button", data-dismiss="modal", aria-hidden="true") &#215;
        h4.modal-title {{$t("connection.modal.title")}}
      .modal-body
        connection(:classes='classes')
        .clearFix
</template>
<script type="text/javascript">
import modalsBus from '@/components/shared/ModalsBus'

import Connection from './Connection'
import $ from 'jquery'

import {mapGetters} from 'vuex'

export default {
  components: {
    Connection
  },
  data () {
    return {
      classes (name) {
        return {
          'button': 'btn-primary btn-connection',
          'socialButton': 'btn-default btn-social'
        }[name]
      }
    }
  },
  mounted () {
    this.selectedGroup = null
    modalsBus.onOpen((arg) => {
      if (arg === modalsBus.modals.CONNECTION) {
        this.open()
      } else {
        this.close()
      }
    })
    modalsBus.onCloseAll(() => {
      this.close()
    })
  },
  beforeDestroy () {
    this.close()
  },
  computed: {
    ...mapGetters('user', [
      'isConnected'
    ])
  },
  methods: {
    open () {
      $(this.$refs.modal).modal('show')
    },
    close () {
      $(this.$refs.modal).modal('hide')
    }
  },
  watch: {
    isConnected () {
      if (this.isConnected) {
        this.close()
      }
    }
  }
}
</script>
<style lang="sass">
.modalConnection
  .modal-body
    .clearFix
      clear: both
  .btn-social 
    margin-top: 15px
  .btn-social, .btn-connection
    &:not(:first-child)
      margin-left: 5px
</style>



// WEBPACK FOOTER //
// ConnectionModal.vue?7899911d